<template>
  <div>
    <TabPanel>
      <!-- 概要 -->
      <app-input-status
        label="概要"
        :message="overviewError"
        :validationError="overviewError ? true : false"
        :success="overview && !overviewError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('overview')"
      />
      <AppTiptap v-model="overview" name="overview" />
      <!-- 概要 -->
    </TabPanel>
    <TabPanel>
      <!-- 備考［任意］ -->
      <app-input-status
        label="備考［任意］"
        :message="remarksError"
        :validationError="remarksError ? true : false"
        :success="remarks && !remarksError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('remarks')"
      />

      <app-text-area
        id="remarks"
        v-model="remarks"
        color="blue"
        rows="15"
        name="remarks"
      ></app-text-area>
    </TabPanel>
    <TabPanel>
      <!-- 画像添付 -->
      <app-input-status label="画像［任意］" />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('files')"
      />
      <AppImageUploader
        @changed="handleImages"
        color="blue"
        colorCode="#2993CE"
        type="result"
      />
    </TabPanel>
    <TabPanel>
      <!-- 資料【旅程表など】［任意］ -->
      <app-input-status label="資料【旅程表など】［任意］" />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('additional_resources')"
      />
      <!-- TODO  @changed="handleImages"でstateの状態変更を追加する必要あり  -->
      <AppFileUploader
        @change="handleFiles"
        type="result"
        color="blue"
        colorCode="#2993CE"
      />
      <!-- 資料【旅程表など】［任意］ -->
    </TabPanel>
    <TabPanel class="mr-5">
      <AppOfficeMessage type="result" color="blue"></AppOfficeMessage>
    </TabPanel>
  </div>
  <button
    id="result-validate-toda"
    style="display: none;"
    @click="resultSubmit()"
  ></button>
</template>

<script>
import { TabPanel } from '@headlessui/vue'
import { onMounted } from 'vue'
import { useResultForm } from '@/services/politicalActionToda/useResultForm'
import AppSentBackItem from '@/components/ui/AppSentBackItem'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppTextArea from '@/components/ui/AppTextArea'
import AppImageUploader from '@/components/ui//uiToda/AppImageUploaderToda.vue'
import AppFileUploader from '@/components/ui/uiToda/AppFileUploader.vue'
import AppTiptap from '@/components/ui/AppTiptap'
import AppOfficeMessage from '@/components/ui/uiToda/AppOfficeMessageToda'
import { useImgUploader } from '@/services/useImgUploader'
import { useFileUploader } from '@/services/useFileUploader'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'

export default {
  name: 'ResultForm_TODA',

  components: {
    TabPanel,
    AppInputStatus,
    AppTiptap,
    AppTextArea,
    AppSentBackItem,
    AppImageUploader,
    AppFileUploader,
    AppOfficeMessage,
  },

  setup() {
    const { imgUploader } = useImgUploader()
    const { fileUploader } = useFileUploader()
    const { currentPoliticalAction } = usePoliticalActions()
    const { handleFiles, handleImages } = useResultForm()
    onMounted(() => {
      let images = []

      if (
        currentPoliticalAction.report.images.length == 1 &&
        currentPoliticalAction.report.images[0].normalImage == null
      ) {
        images = []
      } else {
        for (let i = 0; i < currentPoliticalAction.report.images.length; i++) {
          currentPoliticalAction.report.images[i].blackImage != null
            ? images.push(currentPoliticalAction.report.images[i].blackImage)
            : images.push(currentPoliticalAction.report.images[i].normalImage)
        }
      }
      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images

      let additionalResources = []
      if (currentPoliticalAction.report?.additionalResources?.length == 0) {
        additionalResources = []
      } else {
        for (
          let i = 0;
          i < currentPoliticalAction.report?.additionalResources?.length;
          i++
        ) {
          additionalResources.push(
            currentPoliticalAction.report?.additionalResources[i],
          )
        }
      }

      fileUploader.error = ''
      fileUploader.files = additionalResources
      fileUploader.dropped = 0
      handleFiles(currentPoliticalAction.report?.additionalResources)
      handleImages(currentPoliticalAction.report.images)
    })
    return {
      ...useResultForm(),
    }
  },
}
</script>
<style lang="scss"></style>
